import React, { useState, useCallback } from 'react';
import './SubHeader.css';

export const SubHeader: React.FC<{ url: string }> = ({ url }) => {
  const [copied, setCopied] = useState(false);
  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  }, [url]);

  return (
    <div className="subheader-root">
      <span>Для удалённого редактирования текста:</span>
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="subheader-link"
      >
        ссылка
      </a>
      <button
        onClick={handleCopy}
        className="subheader-copy-btn"
        title="Скопировать ссылку"
      >
        {copied ? '✓' : '⧉'}
      </button>
      {copied && <span className="subheader-copied">Скопировано!</span>}
    </div>
  );
};
